var PROCUREMENT_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxEbsaE4vEm5nGP5sq_wmepLgFVMdWdpGeqgUBIhrov_bahKN_NWu_MhxVE1NQDaf5k/exec';

function ensureProcurementModalAtBodyLevel() {
  var modal = document.getElementById('procurementSignalModal');
  if (modal && modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }
}

function openProcurementSignalModal() {
  ensureProcurementModalAtBodyLevel();
  document.getElementById('procurementSignalModal').style.display = 'flex';
  document.body.style.overflow = 'hidden';
}

function closeProcurementSignalModal() {
  document.getElementById('procurementSignalModal').style.display = 'none';
  document.body.style.overflow = '';
}

document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    closeProcurementSignalModal();
  }
});

document.addEventListener('DOMContentLoaded', function() {

  var form = document.getElementById('procurementSignalForm');

  if (!form) return;

  form.addEventListener('submit', function(event) {

    event.preventDefault();

    var message = document.getElementById('procurementSignalMessage');
    var submitButton = form.querySelector('button[type="submit"]');

    if (submitButton.disabled) return;

    message.textContent = 'Submitting...';
    submitButton.disabled = true;

    fetch(PROCUREMENT_SCRIPT_URL, {
      method: 'POST',
      body: JSON.stringify({

        name: document.getElementById('procurementName').value,
        mobile: document.getElementById('procurementMobile').value,
        organization: document.getElementById('procurementOrganization').value,
        city: document.getElementById('procurementCity').value,
        province: document.getElementById('procurementProvince').value,
        products_needed: document.getElementById('procurementProducts').value,
        estimated_quantity: document.getElementById('procurementQuantity').value,

        notes: '',
        page_url: window.location.href,
        page_title: document.title,
        referrer: document.referrer,
        submitted_at: new Date().toISOString(),
        user_agent: navigator.userAgent,
        source_context: 'procurement_signal_popup'

      })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.text();
    })
    .then(function() {
      message.textContent = 'Submission received. We’ll review it for future supply case planning.';
      form.reset();
    })
    .catch(function() {
      message.textContent = 'There was an error submitting your signal. Please try again.';
    })
    .finally(function() {
      submitButton.disabled = false;
    });

  });

});